import { NavigationService } from 'Services';
import { Creators as FlowActions } from 'Reducers/flow';
import { Creators as ApplicationActions } from 'Reducers/application';

export const onOnline = () => {
  NavigationService.dispatch(ApplicationActions.checkOnline());
  NavigationService.dispatch(FlowActions.forceUpdatePageComponents());
};
